import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Input from '../../components/ui/Input';
import Button from '../../components/ui/Button';
import { useAuth } from '../../context/AuthContext';
const Signup: React.FC = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    password: '',
    confirmPassword: ''
  });
  const [error, setError] = useState('');
  const {
    signup
  } = useAuth();
  const navigate = useNavigate();
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    // Validate passwords match
    if (formData.password !== formData.confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    try {
      await signup(formData);
      navigate('/');
    } catch (err) {
      setError('Error creating account. Please try again.');
    }
  };
  return <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4 py-8" data-id="element-240">
      <div className="max-w-md w-full bg-white rounded-lg border border-gray-200 shadow-md p-8" data-id="element-241">
        <div className="text-center mb-8" data-id="element-242">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bzuBe8K7tpwiJaFhSgXiCs/image.png" alt="Just Cheetah" className="mx-auto h-12 mb-4" data-id="element-243" />
          <h2 className="text-2xl font-semibold" data-id="element-244">Sign Up</h2>
          <p className="text-gray-600 mt-1" data-id="element-245">Create your Just Cheetah account</p>
        </div>
        {error && <div className="mb-4 bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded" data-id="element-246">
            {error}
          </div>}
        <form onSubmit={handleSubmit} data-id="element-247">
          <Input label="Full Name" name="name" placeholder="Enter your full name" value={formData.name} onChange={handleChange} required data-id="element-248" />
          <Input label="Mobile No." name="phone" type="tel" placeholder="Enter your mobile number" value={formData.phone} onChange={handleChange} required data-id="element-249" />
          <Input label="Email" name="email" type="email" placeholder="Enter your email address" value={formData.email} onChange={handleChange} required data-id="element-250" />
          <Input label="Password" name="password" type="password" placeholder="Create a password" value={formData.password} onChange={handleChange} required data-id="element-251" />
          <Input label="Confirm Password" name="confirmPassword" type="password" placeholder="Confirm your password" value={formData.confirmPassword} onChange={handleChange} required data-id="element-252" />
          <div className="mb-6" data-id="element-253">
            <label className="flex items-center" data-id="element-254">
              <input type="checkbox" className="rounded text-[#E84118] focus:ring-[#E84118]" required data-id="element-255" />
              <span className="ml-2 text-sm text-gray-600" data-id="element-256">
                I agree to the{' '}
                <a href="#" className="text-[#E84118]" data-id="element-257">
                  Terms and Conditions
                </a>
              </span>
            </label>
          </div>
          <Button type="submit" fullWidth size="lg" data-id="element-258">
            Create Account
          </Button>
        </form>
        <div className="text-center mt-8 border-t border-gray-200 pt-6" data-id="element-259">
          <p className="text-gray-600" data-id="element-260">
            Already have an account?{' '}
            <Link to="/login" className="text-[#E84118] font-medium hover:underline" data-id="element-261">
              Log In
            </Link>
          </p>
        </div>
      </div>
    </div>;
};
export default Signup;